import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgFor, NgIf, NgClass } from '@angular/common';

interface ResourceType {
  id: string;
  name: string;
  slug?: string; // Optional since it's generated by backend
  icon?: string;
  allowMultiple?: boolean;
  maxConcurrent?: number | null;
  [key: string]: any;
}

/**
 * A curated list of Material icons, including all sport-related icons.
 * See https://fonts.google.com/icons?icon.set=Material+Icons for more.
 */
const MATERIAL_ICONS = [
  // Field-like icons (top for easy access)
  'stadium', 'scoreboard', 'golf_course',
  // General
  'star', 'favorite', 'home', 'person', 'group', 'event', 'school', 'work', 'build', 'settings',
  'check_circle', 'alarm', 'pets', 'flight', 'directions_bus', 'directions_car', 'local_cafe',
  'local_hospital', 'local_library', 'restaurant', 'shopping_cart', 'attach_money', 'local_offer',
  'lock', 'help', 'info', 'lightbulb', 'phone', 'email', 'cloud', 'computer', 'print', 'camera_alt',
  'music_note', 'palette', 'map', 'place', 'public', 'thumb_up', 'visibility', 'wifi', 'battery_full',
  // Sportbar-related
  'sports_bar', 'liquor', 'local_drink',
  // Sport-related (Material Icons)
  'sports', 'sports_baseball', 'sports_basketball', 'sports_cricket', 'sports_esports', 'sports_football',
  'sports_golf', 'sports_gymnastics', 'sports_handball', 'sports_hockey', 'sports_kabaddi', 'sports_martial_arts',
  'sports_mma', 'sports_motorsports', 'sports_rugby', 'sports_score', 'sports_soccer', 'sports_tennis',
  'sports_volleyball', 'emoji_events', 'fitness_center', 'directions_run', 'directions_bike', 'pool', 'rowing',
  'skateboarding', 'sledding', 'snowboarding', 'surfing', 'nordic_walking', 'paragliding', 'scuba_diving'
];

@Component({
  selector: 'app-resourcetype-dialog',
  templateUrl: './resourcetype-dialog.component.html',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
    MatDialogModule,
    MatIconModule,
    MatSelectModule,
    MatCheckboxModule,
    NgFor,
    NgIf,
    NgClass,
  ],
})
export class ResourceTypeDialogComponent {
  materialIcons = MATERIAL_ICONS;
  iconSearch: string = '';
  attemptedSubmit: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ResourceTypeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Partial<ResourceType>
  ) {
    if (!this.data.icon) {
      this.data.icon = '';
    }
    if (this.data.allowMultiple === undefined) {
      this.data.allowMultiple = false;
    }
    if (this.data.maxConcurrent === undefined) {
      this.data.maxConcurrent = null;
    }
  }

  get filteredIcons() {
    if (!this.iconSearch) return this.materialIcons;
    return this.materialIcons.filter((icon) =>
      icon.toLowerCase().includes(this.iconSearch.toLowerCase())
    );
  }

  onSubmit() {
    this.attemptedSubmit = true;
    if (this.data.name && this.data.icon) {
      // Validate maxConcurrent logic
      if (this.data.allowMultiple && this.data.maxConcurrent !== null && this.data.maxConcurrent !== undefined && this.data.maxConcurrent <= 0) {
        return; // Invalid input
      }
      if (!this.data.allowMultiple) {
        this.data.maxConcurrent = null; // Clear maxConcurrent if allowMultiple is false
      }
      this.dialogRef.close(this.data);
    }
  }
}
